import { parseISO } from 'date-fns/parseISO';
import { format, isValid } from 'date-fns';
import { NestedKeyOf } from '../interfaces/ifilter-item.interface';
import { getNestedValue } from './get-nested-value';

export function searchFields<T>(searchText: string, data: T[], searchKeys: NestedKeyOf<T>[]): T[] {
	if (!searchText) return data;

	const lowerSearchText = searchText.toLowerCase();

	return data.filter((item) => {
		return searchKeys.some((field) => {
			const value = getNestedValue(item, field);
			if (value) {
				return matchesSearchText(value, lowerSearchText);
			}
			return false;
		});
	});
}

function isDateTime(value: unknown): value is string {
	if (typeof value !== 'string') return false;
	const date = parseISO(value);
	return isValid(date);
}

function matchesSearchText(value: any, searchText: string): boolean {
	if (typeof value === 'object') {
		return Array.isArray(value) && value.length > 0
			? value.some((tag) => tag.toLowerCase().includes(searchText))
			: JSON.stringify(value).toLowerCase().includes(searchText);
	}

	const stringValue = value.toString().toLowerCase();

	if (stringValue.includes(searchText)) {
		return true;
	}

	if (isDateTime(value)) {
		const date = parseISO(value);
		const formattedVariants = [
			format(date, 'MMMM d'), // May 7
			format(date, 'MMMM d, yyyy'), // May 7, 2025
			format(date, 'MMM d'), // May 7
			format(date, 'MMM d, yyyy'), // May 7, 2025

			// Time only
			format(date, 'h:mm a'), // 6:30 PM
			format(date, 'HH:mm') // 18:30
		].map((str) => str.toLowerCase());

		return formattedVariants.some((f) => f.includes(searchText));
	}

	return false;
}
